export default __webpack_public_path__ + "static/media/noTrack.2a195c38.png";